module.exports = __webpack_public_path__ + "static/img/wxCode.90f686f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/headlines/wxCode.jpg
// module id = 5RRr
// module chunks = 1